export const QUIZZES_PAGE_SIZE = 6

export const QUIZZES_IMAGE_PATH = '/images/quizzes/'
export const QUIZZES_SOUND_PATH = '/sounds/quizzes/'

export const QUIZ_DIFFICULTY = {
  BEGINNER: 'Beginner',
  INTERMEDIATE: 'Intermediate',
  EXPERT: 'Expert',
} as const

export const QUIZ_STATE = {
  NOT_STARTED: 'notStarted',
  INCOMPLETE: 'incomplete',
  COMPLETED: 'completed',
} as const

export const QUIZ_ARENA_STATE = {
  USERNAME_INPUT: 'usernameInput',
  LOADING: 'loading',
  FETCH_PROBLEMS: 'fetchProblems',
  COUNT_DOWN: 'countDown',
  SHOW_PROBLEMS: 'showProblems',
  COMPLETE: 'complete',
} as const

export const QUIZ_USERNAME_LOCAL_STORAGE_KEY = 'quizUsername'

export const OPTION_BUTTON_BG_COLORS = [
  '#406CA9',
  '#509AA4',
  '#E2AB48',
  '#C94E08',
  '#C9089E',
  '#953BAB',
] as const

export const ANSWER_BUTTON_COLOR = { correct: '#7BC177', wrong: '#E63945' }

export const PROBLEM_STEP_COUNT = {
  correct: 1,
  wrong: 2,
}

export const SLIDE_DIRECTION = {
  next: 1,
  previous: -1,
} as const

export const QUIZ_LIST_SECTIONS = {
  PRACTICE: 'All practice quizzes',
  LEADERBOARD: 'Leaderboard',
} as const

export const FALLBACK_QUIZ_DETAILS_PAGE_META_IMAGE =
  'https://fastly.codingal.com/images/meta-image.png'
